import { CodedValueDomain } from '../../bottom-panel/models/attribute-config.model';
import { DomainBoolean } from '../enum/boolean.enum';

export class ConvertUtil {
  static transform(value: any, domain: CodedValueDomain[]): string {
    // set default
    let codedValueName: string = value === undefined || value === null ? '' : value.toString();

    // find name
    if (domain && domain.length > 0) {
      const foundDomain: CodedValueDomain = domain.find(d => d.code === value);
      if (foundDomain) {
        codedValueName = foundDomain.name;
      }
    }

    return codedValueName;
  }

  static transformKeys(value: string, domain: CodedValueDomain[]): string {
    // tranform comma separated keys to corresponding domain values
    if (!value || value.length === 0) return value;
    const formattedValue = value
      .split(',')
      .map(o => domain.find(d => d.code.toString() === o)?.name)
      .join(', ');
    return formattedValue;
  }

  static transformHasValue(value: any, boolDomain: CodedValueDomain[]): string {
    // set default
    return value
      ? boolDomain.find(x => x.code === DomainBoolean.yes).name
      : boolDomain.find(x => x.code === DomainBoolean.no).name;
  }

  static transformToDecimalPercent(value: number): string {
    return value === null || value === undefined ? null : `${Math.round(value * 100)}%`;
  }

  static transformToIntPercent(value: number): string {
    return value === null || value === undefined ? null : `${value}%`;
  }

  static transformListToDomain(list: number[]): CodedValueDomain[] {
    if (!list) {
      return [];
    }

    return list.map(x => {
      return { code: x, name: x.toString() };
    });
  }

  static transformToBooleanDomainValue(value: boolean): number {
    if (value === undefined || value === null) return value === undefined ? undefined : null;
    return Number(value);
  }

  static roundToDecimal(val: number, dec: number): number {
    const factor = Math.pow(10, dec);

    val = Math.round(val * factor) / factor;
    const fixed = val.toFixed(dec);
    return Number(fixed);
  }

  static toFixed(value: number, digits: number) {
    return value ? value.toFixed(digits) : undefined;
  }

  static getFormatedDate(date: Date): string {
    let day = date.getDate().toString();
    let month = (date.getMonth() + 1).toString();
    day = day.length === 1 ? '0' + day : day;
    month = month.length === 1 ? '0' + month : month;

    return `${day}.${month}.${date.getFullYear().toString()}`;
  }

  static formatCsvPercent(value: number, decimal: number): string {
    if (value && typeof value === 'number') {
      return ` (${value.toFixed(decimal)}%)`;
    }
    return '';
  }
}
